export class SubscribeToLicenseRequest {
    VerboseUpdates: boolean;
    LicenseKey: string;
}
